import MarkerClusterer from '@googlemaps/markerclustererplus';
import CustomMarker from './custom-marker';
import { clusterMarkerIcons } from '../../map-config';
const images = require.context('../../../../images/logotypes', true);

function styleObjectToCss(obj) {
    if (!obj || typeof obj !== 'object') return '';
    return Object.entries(obj)
        .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}:${value}`)
        .join(';');
}

/**
 * Apply resolved marker style to a .custom-marker element using the DOM style API
 * (avoids fragile inline HTML strings; browser serializes outerHTML correctly).
 * @param {HTMLElement} wrap - Root .custom-marker node
 * @param {Object|string|null|undefined} style - Flat CSS object, split { root, pin }, raw CSS string, or nullish for default
 */
function applyCustomMarkerStyle(wrap, style) {
    if (!wrap) return;

    if (typeof style === 'string') {
        const pinEl = wrap.querySelector('.custom-marker__pin');
        if (pinEl) pinEl.remove();
        wrap.classList.remove('custom-marker--excluded-split');
        wrap.style.cssText = style;
        return;
    }

    if (style && typeof style === 'object' && style.pin != null && typeof style.pin === 'object') {
        wrap.classList.add('custom-marker--excluded-split');
        let pinEl = wrap.querySelector('.custom-marker__pin');
        if (!pinEl) {
            pinEl = document.createElement('div');
            pinEl.className = 'custom-marker__pin';
            const logo = wrap.querySelector('.custom-marker__logo');
            if (logo) {
                wrap.insertBefore(pinEl, logo);
            } else {
                wrap.appendChild(pinEl);
            }
        }
        wrap.style.cssText = styleObjectToCss(style.root || {});
        pinEl.style.cssText = styleObjectToCss(style.pin);
        return;
    }

    const pinEl = wrap.querySelector('.custom-marker__pin');
    if (pinEl) {
        pinEl.remove();
    }
    wrap.classList.remove('custom-marker--excluded-split');
    wrap.style.cssText = style && typeof style === 'object' ? styleObjectToCss(style) : '';
}

function parseMarkerHtmlToWrap(html) {
    if (!html || typeof html !== 'string') return null;
    const trimmed = html.trim();
    if (!trimmed) return null;
    const template = document.createElement('template');
    template.innerHTML = trimmed;
    return template.content.querySelector('.custom-marker');
}

const LocationHandler = {

    markers: [],
    markerCluster: null,
    _renderGeneration: 0,

    styleObjectToCss,

    createMarker: (map, maps, center, onClick, unit, customMarkerStyles) => {
        let src = null;
        try {
            src = images(`./${unit.chainCode}.png`);
        } catch {
            src = null;
        }

        const wrap = document.createElement('div');
        wrap.className = 'custom-marker';

        const logo = document.createElement('div');
        logo.className = 'custom-marker__logo';
        if (src) {
            const img = document.createElement('img');
            img.src = src;
            img.alt = '';
            logo.appendChild(img);
        }
        wrap.appendChild(logo);

        applyCustomMarkerStyle(wrap, customMarkerStyles);

        const html = wrap.outerHTML;

        let marker = CustomMarker({
          maps,
          latlng: center,
          map,
          html,
          unit
        });
        
        /*const marker = new maps.Marker({
          position: center,
          visible: false,
          map,
          ...options,
        });*/
    
        if (onClick) {
          maps.event.addListener(marker, 'click', (event) => {
            onClick({ units: [unit] });
            event.stopPropagation();
          });
        }
          
        return marker;
    },

    fitBounds: (map, maps) => {
      const bounds = new maps.LatLngBounds();
      LocationHandler.markers.forEach(m => {
        bounds.extend(m.getPosition());
      });
      
      map.setCenter(bounds.getCenter());
      map.fitBounds(bounds);

    },
    

    processMarkerData: (map, maps, locations, disableFitBounds, onClick, cb, createCluster, customMarkerStyles, batchIteration, resolve, bounds = null, generation = null) => {
        if (!bounds) bounds = new maps.LatLngBounds();
        if (generation === null) generation = LocationHandler._renderGeneration;

        // Abort if a newer render has started
        if (generation !== LocationHandler._renderGeneration) {
            return resolve();
        }
    
        const batchedLocations = locations.splice(0, batchIteration);

        if (!batchedLocations.length) {
            if (generation !== LocationHandler._renderGeneration) {
                return resolve();
            }

            if (!disableFitBounds) {
              map.setCenter(bounds.getCenter());
              map.fitBounds(bounds);
            }

          if (createCluster) {
            LocationHandler.createClusters(map, maps, LocationHandler.markers, onClick, cb);
          } else {
            LocationHandler.markers.forEach(marker => {
                if (marker && marker.setMap) {
                    marker.setMap(map);
                }
            });
            if (cb) cb();
          }
         
          return resolve();
        }
    
        requestAnimationFrame(() => {
            if (generation !== LocationHandler._renderGeneration) {
                return resolve();
            }

            batchedLocations.forEach(locationData => {
                if (!locationData.latitude || !locationData.longitude) return;

                const resolvedStyle = typeof customMarkerStyles === 'function'
                    ? customMarkerStyles(locationData)
                    : customMarkerStyles;
    
                const marker = LocationHandler.createMarker(
                    map,
                    maps,
                    new maps.LatLng(
                        locationData.latitude,
                        locationData.longitude
                    ),
                    onClick,
                    locationData,
                    resolvedStyle
                );
                
                if (!createCluster) {
                  marker.setMap(map);
                }

                LocationHandler.markers.push(marker);
                bounds.extend(marker.getPosition());
            });
    
            LocationHandler.processMarkerData(map, maps, locations, disableFitBounds, onClick, cb, createCluster, customMarkerStyles, batchIteration, resolve, bounds, generation);
        });
    },

    createClusters: (map, maps, locations, onClick, cb) => {
        const styles = clusterMarkerIcons();
        
        const clusterStyles = styles.map(style => ({
            className: 'unit-cluster', // Använd CSS-klassen som centrerar texten med flexbox
            height: style.height,
            width: style.width,
            textColor: style.textColor || '#fff',
            textSize: style.textSize || 12,
            textLineHeight: style.height, // Sätt line-height till samma som height för vertikal centrering
            anchorText: [0, 0], // Centrera texten horisontellt och vertikalt (default är [0, 0])
            anchorIcon: [style.height / 2, style.width / 2] // Centrera ikonen
        }));

        LocationHandler.markerCluster = new MarkerClusterer(map, locations, {
            styles: clusterStyles,
            gridSize: 60,
            minimumClusterSize: 5
        });

        maps.event.addListener(LocationHandler.markerCluster, 'clusteringend', () => {
            if (cb) cb();
        });

        maps.event.addListener(LocationHandler.markerCluster, 'clusterclick', (cluster) => {
            if (map.getZoom() > 17) {
                const units = cluster.getMarkers().map(marker => marker.unit).filter(Boolean);
                if (units.length > 0) {
                    onClick({ units });
                }
            }
        });
    },

    updateMarkerStyles(styleFn) {
        LocationHandler.markers.forEach(marker => {
            const style = styleFn ? styleFn(marker.unit) : null;

            let wrap = null;
            if (marker.div) {
                wrap = marker.div.querySelector('.custom-marker');
            } else if (marker.html) {
                wrap = parseMarkerHtmlToWrap(marker.html);
            }

            if (!wrap) {
                return;
            }

            applyCustomMarkerStyle(wrap, style);
            marker.html = wrap.outerHTML;
        });
    },

    removeMarkers() {
        LocationHandler._renderGeneration++;

        if (LocationHandler.markerCluster) {
            LocationHandler.markerCluster.removeMarkers(LocationHandler.markers);
            LocationHandler.markerCluster = null;
        }
        
        LocationHandler.markers.forEach(marker => {
            if (marker && marker.setMap) {
                marker.setMap(null);
            }
        });
        
        LocationHandler.markers = [];
    },

    removeMarkersWithoutClusters() {
      if (LocationHandler.markers) {
        LocationHandler.markers.forEach(marker => {
          marker.setMap(null);
        });
      }
    },

    createLocations: async ({
        map,
        maps,
        units,
        onUnitsLoaded,
        onLoadingComplete,
        disableFitBounds,
        onClick,
        useClusters = true,
        markerStyle = null,
        batchSize = 250
    }) => {
        LocationHandler.removeMarkers();

        if (!units || units.length === 0) {
            if (onLoadingComplete) onLoadingComplete();
            return;
        }

        try {
            const bounds = new maps.LatLngBounds();
            const seen = new Set();
            const dedupedUnits = units.filter(u => {
                if (!u) return false;
                const key = u.companyId ?? u.delfiId ?? `${u.latitude},${u.longitude}`;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
            const locationsQueue = dedupedUnits;

            await new Promise((resolve) => {
                LocationHandler.processMarkerData(
                    map,
                    maps,
                    locationsQueue,
                    disableFitBounds,
                    onClick,
                    useClusters
                        ? () => {
                            if (onLoadingComplete) onLoadingComplete();
                        }
                        : null,
                    useClusters,
                    markerStyle,
                    batchSize,
                    resolve,
                    bounds
                );
            });

            if (!useClusters && onLoadingComplete) {
                onLoadingComplete();
            }
        } catch (error) {
            console.error('Error creating locations:', error);
            if (onLoadingComplete) onLoadingComplete();
        }
    }
};

export default LocationHandler;